import React from "react";
import { Navigate } from "react-router-dom";

function ProtectedRoute({ user, requiredRole, children }) {
  if (!user) {
    return <Navigate to="/" replace />; // Redirect to login if not authenticated
  }

  if (requiredRole && user.role !== requiredRole) {
    return <Navigate to="/" replace />; // Redirect if the user doesn’t have the correct role
  }

  return children; // Render the protected content
}

export default ProtectedRoute;
